import React, { useEffect, useState } from 'react'
// import CommonsService from '@/services/commons.service'
import CommonsService from '@/services/commons.service'
import SignUpService from '@/app-domains/user/onboarding/signup.service'
import config from '@/config'
import { ReactComponent as SecurePaymentIcon } from '@/assets/icons/secure-shield.svg'

import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { centsToDollars } from '@/helpers/currency.helper'
import FlagsService from '@/services/featureFlags/Flags.service'
import { Button } from '@/components/Button/Button'
import { LoadingSpinner } from '@/components/LoadingSpinner'

import './SignUpFourthStep.sass'
import ToastService from '@/components/Toast/Toast.service'
import sessionService from '@/app-domains/user/session/session.service'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

// eslint-disable-next-line
const StripePaymentComponent = (props) => {
  const stripe = useStripe()
  const elements = useElements()
  const [loading, setLoading] = useState(true)

  const onSubmitHandler = async (event) => {
    event?.preventDefault()
    if (!stripe || !elements) return

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.host === 'localhost' ? `http://${window.location.host}/auth/signup/waiting-page` : `http://${window.location.host}/auth/signup/waiting-page`
      },
    })

    if (result.error) {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: result.error.message,
      })
    }
  }

  return <form>
    <PaymentElement onReady={() => {
      props.loaded()
      setLoading(false)
    }} />
    { !loading && <div><Button
      size='large'
      disabled={!stripe}
      content={'Pay Now'}
      click={onSubmitHandler} /></div> }
  </form>
}

export function SignUpFourthStep () {
  const [options, setOptions] = useState({})
  const [loading, setLoading] = useState(true)
  const [stripePromiseReference, setStripePromiseReference] = useState({})
  const [isLoaded, setIsLoaded] = useState(false)
  const [isBYOD] = useState(CommonsService.getQueryParams('isBYOD') === 'true')
  useEffect(() => {
    if (!CommonsService.getQueryParams('domain') && !CommonsService.getQueryParams('isBYOD')) {
      CommonsService.goToPage('/auth/signup/domain-selection')
      return
    }
    SignUpService.generateCustomer().then((data) => {
      setOptions({
        clientSecret: data.clientSecret,
        amounts: data.amounts,
      })
    })
  }, [])

  useEffect(() => {
    FlagsService.init().then(
      () => {
        const isStripeLiveActive = !sessionService.isSandboxSession() && FlagsService.getFlagValue('STRIPE_LIVE_MODE')
        const STRIPE_PK = isStripeLiveActive ? config().REACT_APP_STRIPE_LIVE_PK : config().REACT_APP_STRIPE_TEST_PK
        loadStripe(STRIPE_PK).then(stripePromise => {
          setStripePromiseReference(stripePromise)
          setIsLoaded(true)
        })
      })
  }, [])

  return <div className={`payment-section-container ${loading ? '' : 'section-loaded'}`}>
    {loading && <LoadingSpinner/>}
    <div className="payment-section">
      { options.amounts && !loading && <div className="payment-section-summary">
        <div className="payment-section-summary-title">
          Subscription confirmation
        </div>
        <div className="payment-section-summary-description">
          <div className="payment-item">
            <div className='payment-item-title'>To pay now</div>
            <div className='payment-item-flag'>{centsToDollars(options.amounts.now / 100)}</div>
            <div className='payment-item-description'></div>
          </div>

          <div className="payment-item">
            <div className='payment-item-title'>To pay monthly</div>
            <div className='payment-item-flag monthly'>{centsToDollars(options.amounts.monthly / 100)}</div>
            <div className='payment-item-description'></div>
          </div>
        </div>
      </div> }
      {options.clientSecret && isLoaded &&
        <>
          <Elements stripe={stripePromiseReference} options={options}>
            <StripePaymentComponent isBYOD={isBYOD} loaded={() => setLoading(false)} />
          </Elements>
          <div className='bottom-payment-disclaimer'>
            <SecurePaymentIcon style={{ display: 'inline-flex' }}/> Payment protected through SSL
          </div>
        </>
      }
    </div>
  </div>
}
